import type { Field } from '../../common/types/form';
import type { Documentation } from '../../common/types/documentation';

import dateHoursFields from './dateHoursFields';

const dateHoursParticipantsFields: Field<Documentation>[] = [
  ...dateHoursFields,
  {
    key: 'participants',
    label: 'Zahl der Teilnehmenden',
    fieldTypes: 'number',
  },
];

export default dateHoursParticipantsFields;
